/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMobileDevice
 */
export interface ReadOnlyMobileDevice {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDevice
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMobileDevice
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDevice
     */
    deviceId: string;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMobileDevice
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMobileDevice
     */
    client?: number;
}

export function ReadOnlyMobileDeviceFromJSON(json: any): ReadOnlyMobileDevice {
    return ReadOnlyMobileDeviceFromJSONTyped(json, false);
}

export function ReadOnlyMobileDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMobileDevice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'deviceId': json['device_id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'client': !exists(json, 'client') ? undefined : json['client'],
    };
}

export function ReadOnlyMobileDeviceToJSON(value?: ReadOnlyMobileDevice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'device_id': value.deviceId,
        'client': value.client,
    };
}


